<template>
    <div class="ve-list-page prd-info-page">
        <div style="display:flex;  height:52px;font-size:14px;font-weight:700;color:#333;margin-left:5px">  
            <div  class="oneMenu">
                <div  :class="{active: v_tabName==='material'}" @click="itemClick('material')">
                    <i class="iconfont icon-yuancailiaoxilie" style="font-size:18px; "></i>
                     {{ $LANG('0443', '原材料') }}
                </div> 
            </div>
            <div  class="oneMenu" style="margin-left:30px">
                <div  :class="{active: v_tabName==='product'}" @click="itemClick('product')">
                    <i class="iconfont icon-chanchengpinku" style="font-size:18px; "></i>
                     {{ $LANG('0424', '产成品') }}
                </div> 
            </div>
        </div>
 
            <div v-if="v_tabName =='product'" class="ve-list-page__body " style="margin-top:-12px">
                <div class="prd-info-toolbar">
                    <div class="prd-info-toolbar__content">
                        <span class="prd-info-status-filter">
                            <el-radio-group v-model="stfgSet"  size="mini" @change="stfgChange(stfgSet)">
                                <el-radio   label="ALL"  >{{ $LANG('0321', '所有') }}</el-radio>
                                <el-radio   label="N" >{{ $LANG('1994', '待审核') }}</el-radio>
                                <el-radio  label="Y" >{{ $LANG('0134', '审核') }}</el-radio>
                                <!-- <el-radio border label="X" >作废</el-radio> -->
                            </el-radio-group>
                        </span>
                        <el-select v-model="selparam"  placeholder="" filterable size="small" style="width:150px;margin-left:20px; ">
                            <span v-for="item in tabArr" :key='item.key'>
                                <el-option :label="item.title" :value="item.key"></el-option>
                            </span>
                        </el-select>
                        <el-select v-model="oper"  size="small" style="width:110px; ">
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" @keyup.enter.native="queryEvent(stfgSet)" size="small" style="width:200px;  ">
                            <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent(stfgSet)" style="color:#409eff"></el-button>
                        </el-input> 

                        <el-select v-model="selparam2"  placeholder="" filterable size="small" style="width:150px; ">
                            <span v-for="item in tabArr" :key='item.key'>
                                <el-option :label="item.title" :value="item.key"></el-option>
                            </span>
                        </el-select>
                        <el-select v-model="oper2"  size="small" style="width:110px; ">
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam2" @keyup.enter.native="queryEvent(stfgSet)" size="small" style="width:200px;  ">
                            <el-button size="small" slot="append" icon="el-icon-search" @click="queryEvent(stfgSet)" style="color:#409eff"></el-button>
                        </el-input>
                        <span class="prd-info-field-setting">
                            <i class="iconfont icon-ziyuan"></i>
                            <el-link @click="openProductFieldSettings" :underline="false"><span>{{ $LANG('0683', '字段设置') }}</span></el-link>
                        </span>
                    </div>
                </div> 
                <div class="ve-list-page__table">
                <ve-table
                    :columns="productColumns"
                    :table-data="tabData"
                    :column-hidden-option="productColumnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="_veRowKey"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :event-custom-option="tableEventCustomOption"
                    :max-height="tabHeight"
                    :scroll-width="0"
                    :column-width-resize-option="getColumnWidthResizeOption('product')"
                    v-loading="productLoading"
                    :element-loading-text="$LANG('1959', '加载中，请稍后...')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, .5)"
                    ref="tabref"
                    style="width:100%;margin-top:1px;"
                ></ve-table>
                </div>
                <div class="ve-list-page__pagination">
                    <div style="float: left;font-size:12px;">
                        <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                    </div>
                    <!-- <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
 
                    <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div style="color:#606266;margin:7px 10px;margin-left:80px;font-size:12px;width:30px;">跳至</div>
                    <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                    <span style="color:#606266;margin:7px 5px;font-size:12px;">页</span>
                    <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button> -->
                </div> 
            </div>
            <div v-if="v_tabName =='material'" class="ve-list-page__body prd-info-tab prd-info-tab--material">
            
                <div class="prd-info-toolbar">
                    <div class="prd-info-toolbar__content">
                    <div style="line-height:30px;margin-left:5px;font-size:12px">{{ $LANG('0298', '字段') }}</div>
                    <el-select v-model="selparam3"  placeholder="" filterable size="small" style="width:150px;margin-left:5px; ">
                        <span v-for="item in matArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-select v-model="oper3"  size="small" style="width:110px;  ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam3" size="small" style="width:200px;  ">
                        <el-button slot="append" icon="el-icon-search" @click="queryMat" style="color:#409eff"></el-button>
                    </el-input> 
                    <el-select v-model="selparam4"  placeholder="" filterable size="small" style="width:150px;  ">
                        <span v-for="item in matArr" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-select v-model="oper4"  size="small" style="width:110px;  ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam4" size="small" style="width:200px;  ">
                        <el-button slot="append" icon="el-icon-search" @click="queryMat" style="color:#409eff"></el-button>
                    </el-input> 
                    <span class="prd-info-field-setting">
                        <i class="iconfont icon-ziyuan"></i>
                        <el-link @click="openMaterialFieldSettings" :underline="false"><span>{{ $LANG('0683', '字段设置') }}</span></el-link>
                    </span>
                    </div>
                </div>
                <div class="ve-list-page__table">
                <ve-table
                    :columns="materialColumns"
                    :table-data="matData"
                    :column-hidden-option="materialColumnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="_veRowKey"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :event-custom-option="tableEventCustomOption"
                    :max-height="matHeight"
                    :scroll-width="0"
                    :column-width-resize-option="getColumnWidthResizeOption('material')"
                    v-loading="v_loading"
                    element-loading-background="rgba(255, 255, 255, .5)"
                    :element-loading-text="$LANG('1959', '加载中，请稍后...')"
                    element-loading-spinner="el-icon-loading"
                    ref="refmat"
                    style="width:100%;margin-top:1px;"
                ></ve-table>
                </div>
                <div class="ve-list-page__pagination">
                    <div style="float: left;font-size:12px;">
                        <Page :total="dataCnt" :page-size="rowSize" show-total :current="current" @on-change="chgPage"></Page>
                    </div>
                </div> 
            </div>

        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
        <!-- 编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto;height:88vh;">
                <el-tabs :animated="false"   v-model="active">
                    <el-tab-pane name="first">
                        <span slot="label"><i class="iconfont icon-shujuzidian"></i> {{ $LANG('0536', '产品信息') }}</span>
                        <div v-for="(gpitem,gpind) in formArr" :key="gpind" >
                            <div style="color:#fff;line-height:35px;height:35px;background:#808695;padding-left:5px; margin-bottom:10px; ">
                                <span style="font-weight:600;font-size:14px;color:#fff"><i class="iconfont icon-xuanze1" style="margin-right:6px"></i>{{gpitem.gpnm}} </span>
                            </div>
                            <Form :model="matRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                                <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                    <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                        <el-date-picker :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="matRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        
                                        <el-checkbox :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="matRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                        <el-select :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="matRow[item.FLDNO]"   style="width:100%">
                                            <el-option v-for="(it,ind) in comboArr[item.FLDNO]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                                        </el-select>
                                        <el-input-number :precision="item.DOTNUM" v-else-if="item.EDCSS=='number'" style="width:100%" :disabled="saveFlag" v-model="matRow[item.FLDNO]" controls-position="right"></el-input-number>
                                        <el-input :disabled="saveFlag" v-else-if="item.FLDNO==='OUTPRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                            <el-select slot="append" size="small"  v-model="matRow['OUTCRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px;background:white;">
                                                <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                            </el-select>
                                        </el-input>
                                        <el-input :disabled="saveFlag" v-else-if="item.FLDNO==='PRC'" v-model="matRow[item.FLDNO]" style="width:100%" >
                                            <el-select slot="append" size="small"  v-model="matRow['CRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px;background:white;">
                                                <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                            </el-select>
                                        </el-input>
 
                                        <el-input :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="matRow[item.FLDNO]"></el-input>
                                    </FormItem>
                                </span>
                            </Form>
                            <!-- 产品参数:14737-->
                            <span v-if="gpitem.gpno==='14373'"> 
                                <Form :model="paramRow" :label-width="120" ref="paramWin"  label-position="right" inline >  
                                    <span v-for="(item,index) in paramArr" :key="index" >
                                        <FormItem  :label="item.cname"  class="item-width"  >
                                            <span v-if="item.ishand==='Y'">
                                                <el-input :disabled="saveFlag" clearable :placeholder="$LANG('1663', '请输入')"  @keydown.native="inputChange" @keyup.native="inputChange"  v-model="paramRow[item.lstseq]" style="width:100%"></el-input>
                                            </span>
                                                <span v-else>
                                                <el-select :disabled="saveFlag" :placeholder="$LANG('1664', '请选择')"   @change="modelChange" v-model="paramRow[item.lstseq]"  style="width:100%" filterable clearable>
                                                    <el-option v-for="(it,ind) in item.children" :key="ind" :value="it.code" :label="it.cname" ></el-option>
                                                </el-select> 
                                            </span>
                                        </FormItem>
                                    </span>
                                </Form>
                            </span>
                            <!-- 产品图片:14374 -->
                            <span v-if="gpitem.gpno==='14374'"> 
                                <div style="display:flex" >

                                    <div style="display:flex;margin-left:30px;"  >
                                        <span v-for="(item,index) in imgData" :key="index">  
                                            <el-image :disabled="saveFlag" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
 
                                                <el-link :underline="false" @click="imgPreview(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                                            </div>
                                        </span>
                                    </div> 
                                </div>
                            </span>
                            <!-- 数据手册:14375  -->
                            <span v-if="gpitem.gpno==='14375'"> 
                                <div style="display:flex" >

                                    <div v-if="pdfUrl.length>2" style="display:flex;flex-direction:column;height:200px;margin-left:100px;"  >
                                        <div style="height:35px;background:#e8eaec;width:300px; display:flex;justify-content:center">
                                            <el-link :underline="false" style="margin-right:100px;" @click="pdfViewer"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                                         
                                        </div> 
                                        <div style="width:300px;height:165px;border:1px solid #e8eaec;overflow-y:hidden">
                                            <iframe :src="pdfUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                        </div>
                                    </div> 
                                </div>
                            </span>
                        </div>
                    </el-tab-pane>
                        
                </el-tabs>
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right" >
                    <el-button :disabled="prevFlag" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">{{ $LANG('0519', '上行记录') }}</el-button>
                    <el-button :disabled="nextFlag" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">{{ $LANG('0525', '下行记录') }}</el-button>
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
  
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promtWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
 
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="matWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto;height:88vh;">
                <span v-for="(gpitem,gpind) in formMat" :key="gpind" >
        
                    <div  class="one-div">
                        <span class="oneRow">
                            <span v-if="gpitem.gpno==='14373'" style="font-weight:600;font-size:14px;color:black">{{ $LANG('1286', '物料类别属性') }} </span>
                            <span v-else-if="gpitem.gpno==='14374'" style="font-weight:600;font-size:14px;color:#5cadff">{{ $LANG('0858', '物料图片') }} </span>
                            <span v-else-if="gpitem.gpno==='14375'" style="font-weight:600;font-size:14px;color:#5cadff">{{ $LANG('1284', '物料技术手册') }} </span>
                            <span v-else style="font-weight:600;font-size:14px;color:black; ">{{gpitem.gpnm}} </span>   
                        </span>  
                    </div>    
                        <Form :model="rawRow" :label-width="120"   label-position="right" inline  >  
                            <span v-for="(item,index) in gpitem.gplist" :key="index" >
                                <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                    <el-date-picker  disabled  type="date"  v-if="item.EDCSS==='date'" v-model="rawRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                    <el-input  disabled  v-enter-number  v-else-if="item.EDCSS==='number'" v-model="rawRow[item.FLDNO]" style="width:100%" ></el-input>   
                                    <el-checkbox border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="rawRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                    <el-select  disabled  v-else-if="item.EDCSS==='select'" v-model="rawRow[item.FLDNO]"   style="width:100%">
                                        <el-option v-for="(it,ind) in comboArr[item.FLDNO]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                                    </el-select>
                                    <el-input v-else-if="item.FLDNO==='OUTPRC'" v-model="rawRow[item.FLDNO]" style="width:100%" >
                                        <el-select slot="append" size="small"  v-model="rawRow['OUTCRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px;background:white;">
                                            <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>
                                    </el-input>
                                    <el-input v-else-if="item.FLDNO==='PRC'" v-model="rawRow[item.FLDNO]" style="width:100%" >
                                        <el-select slot="append" size="small"  v-model="rawRow['CRCY']" :placeholder="$LANG('1686', '请选择货币')"  style="width:140px;background:white;">
                                            <el-option v-for="(item,index) in crcyArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>
                                    </el-input>

                                    <el-input :placeholder="item.HOLDER" type="text" v-else disabled v-model="rawRow[item.FLDNO]"></el-input>
                                </FormItem>
                            </span>
                        </Form>
                        <!-- 物料参数:14737-->
                        <span v-if="gpitem.gpno==='14373'"> 
                            <Form :model="paramRow" :label-width="120" ref="paramWin"  label-position="right" inline >  
                                <span v-for="(item,index) in paramArr" :key="index" >
                                    <FormItem  :label="item.cname"  class="item-width" :prop="item.code"  >
                                        <el-input disabled :placeholder="$LANG('1663', '请输入')" v-if="item.ishand==='Y'" type="text" @keydown.native="inputChange" @keyup.native="inputChange"  v-model="paramRow[item.lstseq]" style="width:100%"></el-input>
                                        <el-select disabled :placeholder="$LANG('1664', '请选择')" v-else @change="modelChange" v-model="paramRow[item.lstseq]"  style="width:100%" filterable clearable>
                                            <el-option v-for="(it,ind) in item.children" :key="ind" :value="it.code" :label="it.cname" ></el-option>
                                        </el-select> 
                                    </FormItem>
                                </span>
                            </Form>
                        </span>
                        <!-- 物料图片:14374 -->
                        <span v-if="gpitem.gpno==='14374'"> 
                            <div style="display:flex" >
                                <div style="display:flex;margin-left:30px;"  >
                                    <span v-for="(item,index) in imgArr" :key="index">  
                                        <el-image :disabled="saveFlag" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">

                                            <el-link :underline="false" @click="imgPreview(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                                        </div>
                                    </span>
                                </div> 
                            </div>
                        </span>
                        <!-- 数据手册:14375  -->
                        <span v-if="gpitem.gpno==='14375'"> 
                            <div style="display:flex" >
                                <div v-if="pdfMat.length>2" style="display:flex;flex-direction:column;height:200px;margin-left:100px;"  >
                                    <div style="height:35px;background:#e8eaec;width:300px; display:flex;justify-content:center">
                                        <el-link :underline="false" style="margin-right:100px;" @click="matViewer"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>

                                    </div> 
                                    <div style="width:300px;height:165px;border:1px solid #e8eaec;overflow-y:hidden">
                                        <iframe :src="pdfMat" frameborder="0" style="width: 100%; height: 100%"></iframe>
                                    </div>
                                </div> 
                            </div>
                        </span>
                </span>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right" >

                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" @click="matWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>

                </span>
            </div>
        </el-dialog>
    
    </div> 
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate } from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
 
//局部注册
export default {
    name:"prduction_info",
    mixins: [
        createVeTableFieldSettingMixin({
            grids: {
                product: {
                    settingFormId: '4272',
                    fieldIdseq: '4272',
                    fieldLstseq: '1',
                    mainColumnKey: 'tabArr',
                    initColumnKey: 'productInitCol',
                    tableColumnKey: 'productColumns',
                    tableRef: 'tabref',
                    columnHiddenOptionKey: 'productColumnHiddenOption',
                    generatedFixedColumnKeys: ['rownum', 'oper'],
                    syncMainColumnSettings: true,
                },
                material: {
                    settingFormId: '15691',
                    fieldIdseq: '15691',
                    fieldLstseq: '1',
                    mainColumnKey: 'matArr',
                    initColumnKey: 'materialInitCol',
                    tableColumnKey: 'materialColumns',
                    tableRef: 'refmat',
                    columnHiddenOptionKey: 'materialColumnHiddenOption',
                    generatedFixedColumnKeys: ['rownum', 'oper'],
                    syncMainColumnSettings: true,
                },
            },
        })
    ],
    data () {
        return {
            matData:[],
            prevFlag:false,
            nextFlag:false,
            crcyArr:[],
            nodeLabel:this.$LANG('0546', '产品类别'),
            treeid:'0',  
            filterText:'',  
            v_tabName:'material',
            ishand:'',
            cname:'',
            stfg:'',
            sortby:'',
            drawer:false,
            matWin:false,
            dataCnt:0,
            showViewer:false,
 
            saveFlag:false,
            promtWin:false,
            prompt:'',
            stfgCss:'',
            active:'first',
            perWin:false,
            stfgColor:'',
            rawRow:{},
            matRow:{},
            listurl:'',//放大的图片
            
            allList:[],
            matArr:[],
            materialInitCol:[],
            materialColumns:[],
            materialColumnHiddenOption: { defaultHiddenColumnKeys: [] },
            materialHeaderRow:{},
            materialSortKey:'',
            materialSortOrder:'',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            formMat:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            productInitCol:[],
            productColumns:[],
            productColumnHiddenOption: { defaultHiddenColumnKeys: [] },
            productHeaderRow:{},
            productSortKey:'',
            productSortOrder:'',
            paramArr:[], //属性数组
            paramRow:{},
            imgData:[],
            delImg:[],
            txtparam3:'',
            selparam3:'IDNO',
            oper3:'like',
            txtparam4:'',
            selparam4:'IDNO',
            oper4:'like',
            oper:'like',
            imgArr:[],
            operArr:[],
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            txtparam2:'',
            selparam2:'',
            oper2:'like',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:100,
            goPage:'',
            propData:[],
            notNull:[],
            uploadData:{}, //上传数据
            current:1,
            imgSrc:'',
            specForm:{
                PROPNM:'',
                COUNT:0,
                CNT:0,
            },
            paramIndex:'',
            paramIdseq:'',
            paramLstseq:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                }],
 
            specIdseq:'', //规格主键
            specLstseq:'',//规格主键
            specData:[], //规格集合
            v_loading:false,
            productLoading:false,
            productQueryRequestId:0,
            materialQueryRequestId:0,
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            specFlag:'create',
            specVal:'',
            specSort:'',
            specIndex:'',
            fileName:'',
            delPdf:'',
            pdfUrl:'N',
            pdfMat:'N',
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限  
        // getBaseData('xuper_auth/getBaseData','idseq',this.$cookies.get('v_idseq') ,'frmidseq','4272','v_sys_user_priv','').then(res=>{           
        //     if (this.v_admin==='N') { //表示有权限控制
        //         let row =res.result[0]
        //         if (row.ISADD==='N'){ //新增
        //             this.addBool=true
        //         }if (row.ISUPD==='N'){ //修改
        //             this.editBool=true
        //         }if (row.ISDEL==='N'){ //删除
        //             this.delBool=true
        //         }if (row.ISCFM==='N'){ //审核
        //             this.cfmBool=true
        //         }if (row.ISCANCEL==='N'){ //作废
        //             this.cancelBool=true
        //         }
        //     }
        // })  
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','PARENTNO','4237','','','v_sys_base','').then(res=>{
            this.crcyArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','4272','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            } 
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','15691','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formMat = res.result             
            } 
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
 
    },
    computed: {
        matHeight: function() {
            return (window.innerHeight - 200) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 200) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        },
        tableEventCustomOption: function() {
            return {
                bodyRowEvents: ({ row }) => ({
                    click: () => this.rowClick(row),
                }),
            }
        },
    },
    components: {
        VeColumnConfigDialog,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.queryEvent(this.stfgSet)
            this.getTabField() //表列字段
            this.queryMat()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    methods: {
        itemClick(val){
            this.v_tabName =val     
        },
        openProductFieldSettings(){
            return this.openFieldSettingsDialog('product').catch(error => {
                this.promtWin =true
                this.prompt =error.message || '字段设置加载失败'
            })
        },
        openMaterialFieldSettings(){
            return this.openFieldSettingsDialog('material').catch(error => {
                this.promtWin =true
                this.prompt =error.message || '字段设置加载失败'
            })
        },
        setHeaderValue(configKey, key, value){
            const row =configKey === 'product' ? this.productHeaderRow : this.materialHeaderRow
            this.$set(row, key, value)
        },
        queryByHeader(configKey){
            this.current =1
            if (configKey === 'product') this.queryEvent(this.stfgSet)
            else this.queryMat()
        },
        clearHeaderQuery(configKey){
            if (configKey === 'product') {
                this.productHeaderRow ={}
                this.productSortKey =''
                this.productSortOrder =''
                this.queryEvent(this.stfgSet)
            } else {
                this.materialHeaderRow ={}
                this.materialSortKey =''
                this.materialSortOrder =''
                this.queryMat()
            }
        },
        sortGrid(configKey, field){
            const sortKey =configKey === 'product' ? 'productSortKey' : 'materialSortKey'
            const sortOrder =configKey === 'product' ? 'productSortOrder' : 'materialSortOrder'
            this[sortOrder] =this[sortKey] === field && this[sortOrder] === 'asc' ? 'desc' : 'asc'
            this[sortKey] =field
            const direction =this[sortOrder] === 'asc' ? 1 : -1
            const dataKey =configKey === 'product' ? 'allData' : 'allList'
            this[dataKey] =this[dataKey].slice().sort((left, right) => {
                const leftValue =left[field]
                const rightValue =right[field]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined) return -direction
                if (rightValue === null || rightValue === undefined) return direction
                const leftNumber =Number(leftValue)
                const rightNumber =Number(rightValue)
                if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) return (leftNumber - rightNumber) * direction
                return String(leftValue).localeCompare(String(rightValue)) * direction
            })
            if (configKey === 'product') this.initPage()
            else this.chgPage(this.current)
        },
        queryMat(){
            let cond_=buildVeTableFieldCondition(this.materialInitCol, this.selparam3, this.txtparam3, this.oper3)
            cond_+=buildVeTableFieldCondition(this.materialInitCol, this.selparam4, this.txtparam4, this.oper4)
            cond_+=buildVeTableHeaderCondition(this.materialInitCol, this.materialHeaderRow)
            //只查用户所对应的 采购订单 产品
            if (this.v_username !=='18025667613'){
                cond_= cond_+ ' and idno in (select matno from v_po_orddtl where phoneno=\''+this.v_username+'\')'    
            }        
            this.getRawList(cond_)
        },
        //上行、下行记录
        prevRec(){
            this.rowIndex--
            this.nextFlag=false
            if (this.rowIndex<0){
                this.rowIndex=0
                this.prevFlag=true
            }
            this.rowClick(this.allData[this.rowIndex])
            this.matClick(this.allData[this.rowIndex])
        },
        nextRec(){
            this.rowIndex++
            this.prevFlag=false
            if (this.rowIndex>this.allData.length){
                this.rowIndex=this.allData.length
                this.nextFlag=true
            }
            this.rowClick(this.allData[this.rowIndex])
            this.matClick(this.allData[this.rowIndex])
        },
        matViewer(){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:this.pdfMat },
            });
            window.open(routeUrl.href, '_blank');
        },   
        //预览PDF
        pdfViewer(){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:this.pdfUrl },
            });
            window.open(routeUrl.href, '_blank');
        },
        rawClick(row){
            //行赋值    
            this.rawRow =JSON.parse(JSON.stringify(row))  //深拷贝
            if (row.PDFPATH){
                this.pdfMat =row.PDFPATH
            }else{
                this.pdfMat ='N'
            }
            //产品参数   
            this.paramArr=[]
            this.getProdParam(row.MATTY) //来自于物料属性库
            //产品参数值 selSpecValue
            this.paramRow={}
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'mat_spec'},
            }).then(res=>{      
                for (let k=0;k<res.result.length;k++){   
                    this.paramRow[res.result[k]['REFLSTSEQ']] =res.result[k]['CODE']       
                }
            })         
            //产品图片
            this.qryImgArr(row.IDSEQ) 
        },
        //重新刷新产品属性和 属性值
        getProdParam(idseq){
            //产品参数   
            let cond_=' and (idseq='+idseq+' or idseq=(select parentno from bs_type where code=\''+idseq+'\')) order by sortby,lstseq'
            this.$axios({
                method: 'post',
                url:'xuper_auth/getPrdSpec',
                data: { p_key2:'STFG',p_value2:'Y',p_cond:cond_,p_table:'V_PRD_PROP'},
            }).then(res=>{      
                this.paramArr =res.result 
            }) 
        },
        modelChange(){
            this.$forceUpdate()
        },
        inputChange(){
            this.$forceUpdate()
        },
 
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
   
        },
        matClick(row){
            //行赋值    
            this.matRow =JSON.parse(JSON.stringify(row))  //深拷贝
            if (row.PDFPATH){
                this.pdfUrl =row.PDFPATH
            }else{
                this.pdfUrl ='N'
            }
            //产品参数   
            this.paramArr=[]
            this.getProdParam(row.MATTY) //来自于物料属性库
            //产品参数值 selSpecValue
            this.paramRow={}
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'mat_spec'},
            }).then(res=>{      
                for (let k=0;k<res.result.length;k++){   
                    this.paramRow[res.result[k]['REFLSTSEQ']] =res.result[k]['CODE']       
                }
            })         
            //产品图片
            this.qryImgData(row.IDSEQ) 
        },
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        qryImgArr(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgArr=[]
                if (res){
                    this.imgArr =res.result
                }
            })
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
  
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'4272',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        getRawList(cond){
            this.v_loading =true
            const requestId =++this.materialQueryRequestId
            return this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'MAT',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_BS_mat'},
            }).then(res=>{ 
                if (requestId !== this.materialQueryRequestId) return
                if (res.code==='200'){
                    const rows =Array.isArray(res.result) ? res.result : []
                    this.allList=this.decorateTableRows(rows, 'material')
                    this.dataCnt =this.allList.length //总条数
                    // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                    if (this.allList.length < this.rowSize){
                        this.matData = this.allList          
                    }else{       
                        this.matData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素               
                    }
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }).catch(error => {
                if (requestId !== this.materialQueryRequestId) return
                this.allList=[]
                this.matData=[]
                this.dataCnt=0
                this.promtWin=true
                this.prompt=error.message || '查询失败'
            }).finally(() => {
                if (requestId === this.materialQueryRequestId) this.v_loading =false
            })
        },
        //产品明细
        getMatList(cond){
            //获取所有产品记录且初始化分页记录         
            this.productLoading =true
            const requestId =++this.productQueryRequestId
            return this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'PRD',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_BS_mat'},
            }).then(res=>{ 
                if (requestId !== this.productQueryRequestId) return
                if (res.code==='200'){
                    const rows =Array.isArray(res.result) ? res.result : []
                    this.allData =this.decorateTableRows(rows, 'product')
                    this.initPage() 
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
            }).catch(error => {
                if (requestId !== this.productQueryRequestId) return
                this.allData=[]
                this.tabData=[]
                this.dataCount=0
                this.promtWin=true
                this.prompt=error.message || '查询失败'
            }).finally(() => {
                if (requestId === this.productQueryRequestId) this.productLoading =false
            })
        },
        decorateTableRows(rows, prefix){
            return rows.map((row, index) => Object.assign({}, row, {
                _veRowKey: `${prefix}-${row.IDSEQ === undefined || row.IDSEQ === null ? index : row.IDSEQ}`,
            }))
        },
   
 
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
   
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        chgPage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.matData = this.allList.slice(_start,_end);
        },
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='N'){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.matClick(row)
            this.drawer=true 
            this.rowIndex=index         
        },
        matRec(row,val,index){
            this.rawClick(row)
            this.matWin=true    
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
  
        //状态查询
        stfgChange(val){
            this.queryEvent( val )
        },
 
        queryEvent(val ){
            let cond_=buildVeTableFieldCondition(this.productInitCol, this.selparam, this.txtparam, this.oper)
            cond_+=buildVeTableFieldCondition(this.productInitCol, this.selparam2, this.txtparam2, this.oper2)
            cond_+=buildVeTableHeaderCondition(this.productInitCol, this.productHeaderRow)
            //只查用户所对应的 采购订单 产品
            cond_= cond_+ ' and idno in (select matno from v_po_orddtl where phoneno=\''+this.v_username+'\')' 
     
            if (val=='ALL'){
                cond_= cond_+   ' and stfg!=\'X\'' 
            }else  {    
                cond_= cond_+   ' and stfg =\''+val+'\''
            }
           
            this.getMatList(cond_)
        },
        normalizeTableFields(rows){
            return (Array.isArray(rows) ? rows : []).map(item => Object.assign({}, item, {
                title: this.$translate.getColTitle(item, this.$store.state.lang) || item.title || item.FLDNM || item.CNAME || item.key || item.FLDNO,
                key: item.key || item.FLDNO,
                align: item.align || item.ALIGN || 'left',
                width: Number(item.width || item.WIDTH) || 100,
                thide: item.THIDE === undefined ? item.thide : item.THIDE,
                fhide: item.FHIDE === undefined ? item.fhide : item.FHIDE,
                disabled: item.DISABLED === undefined ? item.disabled : item.DISABLED,
                sortable: item.SORTABLE === undefined ? item.sortable : item.SORTABLE,
                edcss: item.EDCSS === undefined ? item.edcss : item.EDCSS,
            }))
        },
        buildQueryHeader(field, configKey){
            const row =configKey === 'product' ? this.productHeaderRow : this.materialHeaderRow
            const sortKey =configKey === 'product' ? this.productSortKey : this.materialSortKey
            const sortOrder =configKey === 'product' ? this.productSortOrder : this.materialSortOrder
            const sortable =field.key !== 'RN' && field.sortable === 'N' && field.edcss !== 'checkbox'
            return ({ column }, h) => h(VeTableQueryHeader, {
                props: {
                    title: column.title,
                    edcss: field.edcss,
                    value: row[field.key],
                    operator: row[`#OPER${field.key}`],
                    defaultOperator: field.edcss === 'number' ? '>=' : '=',
                    options: this.comboArr[field.key] || [],
                    sortable,
                    sortOrder: sortKey === field.key ? sortOrder : '',
                },
                on: {
                    input: value => this.setHeaderValue(configKey, field.key, value),
                    'operator-change': value => this.setHeaderValue(configKey, `#OPER${field.key}`, value),
                    query: () => this.queryByHeader(configKey),
                    'title-click': () => this.sortGrid(configKey, field.key),
                },
            })
        },
        buildDataColumn(field, configKey){
            return {
                field: field.key,
                key: field.key,
                title: field.title,
                width: this.getFieldWidth(field.key, field.width, configKey),
                align: field.align,
                disabled: field.disabled,
                ellipsis: { showTitle: true },
                renderHeaderCell: this.buildQueryHeader(field, configKey),
                renderBodyCell: ({ row }, h) => {
                    const rowValue =row[field.key]
                    if (field.edcss === 'checkbox') {
                        return h('el-checkbox', {
                            props: { disabled: true, value: rowValue, trueLabel: 'Y', falseLabel: 'N' },
                        })
                    }
                    if (field.key === 'IMGPATH' || field.edcss === 'image') {
                        return (
                            <el-image style="width:100%;height:20px;" src={rowValue} preview-src-list={rowValue ? [rowValue] : []}>
                                <div slot="error"><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        )
                    }
                    return rowValue
                },
            }
        },
        buildGridColumns(configKey){
            const metadata =configKey === 'product' ? this.productInitCol : this.materialInitCol
            const operationWidth =configKey === 'product' ? 80 : 82
            const columns =this.sortFieldRows(metadata, configKey)
                .filter(field => field.thide === 'N')
                .map(field => this.buildDataColumn(field, configKey))
            const rowNumberColumn ={
                field: 'index',
                key: 'rownum',
                title: this.$LANG('0310', '序号'),
                width: 60,
                align: 'center',
                fixed: 'left',
                disableResizing: true,
                renderHeaderCell: ({ column }) => (
                    <div>
                        <div style="margin-top:3px">{column.title}</div>
                        <el-link underline={false} on-click={() => this.clearHeaderQuery(configKey)} style="font-size:12px;color:#404eff;height:30px">
                            <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                        </el-link>
                    </div>
                ),
                renderBodyCell: ({ rowIndex }) => rowIndex + (this.current - 1) * this.rowSize + 1,
            }
            const operationColumn ={
                field: 'oper0',
                key: 'oper',
                title: this.$LANG('0330', '操作'),
                width: operationWidth,
                align: 'center',
                fixed: 'right',
                disableResizing: true,
                renderBodyCell: ({ row, rowIndex }) => (
                    <div>
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link
                            disabled={configKey === 'material' && this.disabled}
                            underline={false}
                            on-click={() => configKey === 'product' ? this.editRec(row, 'Y', rowIndex) : this.matRec(row, 'Y', rowIndex)}
                        ><span style="font-size:11px;margin-right:4px;">{this.$LANG('0139', '查看')}</span></el-link>
                    </div>
                ),
            }
            const targetKey =configKey === 'product' ? 'productColumns' : 'materialColumns'
            this[targetKey] =[rowNumberColumn].concat(columns, operationColumn)
            this.applyFieldSettingRows(configKey)
        },
        //获取表列字段
        getTabField(){
            const loadProduct =getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then(async res => {
                this.productInitCol =this.normalizeTableFields(res && res.result)
                this.tabArr =this.productInitCol.map(item => Object.assign({}, item))
                await this.loadInitialFieldSettings('product')
                this.buildGridColumns('product')
            })
            const loadMaterial =getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15691','lstseq','1','','',' order by sortby,lstseq').then(async res => {
                this.materialInitCol =this.normalizeTableFields(res && res.result)
                this.matArr =this.materialInitCol.map(item => Object.assign({}, item))
                await this.loadInitialFieldSettings('material')
                this.buildGridColumns('material')
            })
            return Promise.all([loadProduct, loadMaterial])
        }
    }
}
</script>
<style scoped lang="less">
    .prd-info-page {
        height: calc(100% - 32px);
    }
    .prd-info-tab {
        margin-top: 10px;
    }
    .prd-info-toolbar {
        flex: 0 0 38px;
        height: 38px;
        min-width: 0;
        overflow-x: auto;
        overflow-y: hidden;
        line-height: 30px;
        border-bottom: 2px solid #389;
        background: #f1f2f3;
        box-sizing: border-box;
    }
    .prd-info-toolbar__content {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        min-width: 1380px;
        height: 36px;
        padding-top: 3px;
        box-sizing: border-box;
    }
    .prd-info-toolbar__content > * {
        flex-shrink: 0;
    }
    .prd-info-status-filter {
        display: inline-flex;
        align-items: center;
        flex: 0 0 250px;
        margin-left: 8px;
        white-space: nowrap;
    }
    .prd-info-status-filter /deep/ .el-radio-group {
        display: inline-flex;
        align-items: center;
        flex-wrap: nowrap;
    }
    .prd-info-status-filter /deep/ .el-radio {
        margin-right: 16px;
        white-space: nowrap;
    }
    .prd-info-field-setting {
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
        margin-left: 15px;
        margin-right: 15px;
        white-space: nowrap;
        font-size: 12px;
    }
    .prd-info-field-setting .iconfont {
        margin-right: 5px;
        color: #409EFF;
        font-size: 14px;
    }
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        height:30px;
        line-height:30px;
        background:white;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .active { 
        border-bottom:3px solid #cc0000;
        color:#389;
    }
    .wraper{
        width:1250px;
        margin:1px auto;
    }
         ::-webkit-scrollbar {
    width: 4px;
  }
 
  ::-webkit-scrollbar-track {
    background-color: #f5f7f9;
  }
    
    ::-webkit-scrollbar-thumb {
    background-color: #acd6ff;
    }
    
    ::-webkit-scrollbar-thumb:hover {
    background-color: #acd6ff;
    }
    
    ::-webkit-scrollbar-thumb:active {
    background-color: #acd6ff;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
     .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
